import { AuthViewModel } from "@lumora/core";
import { SignInForm } from "@lumora/ui";
import { useMemo } from "react";
import { Link, useNavigate } from "react-router-dom";
import { ADMIN_SITE, platformClient } from "../../platformClient.js";

export function PlatformSignInPage() {
  const navigate = useNavigate();
  const vm = useMemo(() => new AuthViewModel(platformClient, ADMIN_SITE), []);

  return (
    <div className="site-signin">
      <p className="site-signin-kicker">Lumora staff</p>
      <h1>Platform sign in</h1>
      <p className="site-signin-lead">
        Admin access to live ops, activity, and tenant backends.
      </p>
      <SignInForm
        viewModel={vm}
        title="Platform sign in"
        showTitle={false}
        onSignedIn={() => navigate("/platform/ops", { replace: true })}
      />
      <p className="muted site-signin-foot">
        Customer sign-in? <Link to="/signin">Owner portal</Link>
      </p>
    </div>
  );
}
